import React from 'react'
import "./OnBoarding.css";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { PROJECT_DISPLAY_NAME } from '../../../config/apiConfig';


export default function Congratulations() {
  return (
    <div className="congratulations_wrapper">
      <div className='cong_main_block'>
        <div className="congratulations_block">
            <div className='img_congratulations'>
              <img src="/img/onboarding_img.png" className="congratulations_main_img" alt="congratulations_img"/>
              <h5 className='cong_head'>Congratulations!</h5>
              <p className='cong_para'>You are all set to start using {PROJECT_DISPLAY_NAME} </p>
              <Button className="lets_explore">
                    Let's Explore <i className="fa fa-arrow-right" aria-hidden="true"></i>
              </Button>
            </div>
        </div>
      </div>
    </div>
  )
}
